import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../share-components/AppContext';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { ROUTE_ADMIN_ACCOUNTS } from '../../constants/routeConstants';
import { Button, Card } from 'react-bootstrap';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import { createAccount } from '../../services/AccountService';
import AlertDialog from '../../share-components/AlertDialog';
import FormTitle from '../../share-components/FormTitle';
import { SERVER_ERROR_MESSAGE } from '../../constants/commonConstants';

const CreateAccount = () => {
    const { setLoading, setShowApiErrorMessage, setRouteNaviData } = useAppContext();
    const [showPassword, setShowPassword] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setRouteNaviData("MASTER >> CREATE ACCOUNT")
    }, [])

    const initialValues = {
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
    };

    const validationSchema = Yup.object({
        username: Yup.string()
            .min(3, 'Username must be at least 3 characters long.')
            .max(20, 'Username must not exceed 20 characters.')
            .required('Username is required.'),
        email: Yup.string()
            .email('Invalid email format.')
            .required('Email is required.')
            .max(100, 'Email must not exceed 100 characters.'),
        password: Yup.string()
            .min(6, 'Password must have at least 6 characters.')
            .max(50, 'Password must not exceed 50 characters.') // Max length validation
            .matches(/^[A-Za-z0-9!@#$%^&*()_+=-]+$/, 'Password can only contain alphabets, numbers, and special characters.')
            .required('Password is required.'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match.')  // Check if confirmPassword matches password
            .required('Confirm Password is required.')
    });

    const onSubmit = async (form) => {
        setLoading(true);
        try {
            const createdUserId = await createAccount(form.username, form.email, form.password);
            setShowSuccessDialog(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if(error.status !== 401 && error.status !== 403){
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSuccessDialogClose = () => {
        setShowSuccessDialog(false);
        navigate(ROUTE_ADMIN_ACCOUNTS);
    }

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: '30px' }}>
                {/* Header */}
                <h2 className="text-center" style={{ color: "var(--mainHeaderColor)" }}>BEAUTY TREASURE</h2>

                {/* Login Form */}
                <Card style={{ width: '100%', maxWidth: '400px', padding: '20px', margin: '0 auto' }}>
                    <Card.Body>
                        <FormTitle title={"Create New Admin Account"} isCenter={true}/>
                        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                            {({ errors, isValid, dirty }) => {
                                const firstError = !dirty ? "Fill the required fields." : Object.values(errors)[0];
                                return (
                                    <Form>
                                        <div className="mb-3">
                                            <label className="form-label custom-label">Username*</label>
                                            <Field name="username" type="text" className="form-control customInputControl" autoComplete="off" />
                                            <ErrorMessage name="username" component="div" className="text-danger" />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label custom-label">Email*</label>
                                            <Field name="email" type="text" className="form-control customInputControl" autoComplete="off" />
                                            <ErrorMessage name="email" component="div" className="text-danger" />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label custom-label">Password*</label>
                                            <Field name="password" type={showPassword ? 'text' : 'password'} className="form-control customInputControl" />
                                            <ErrorMessage name="password" component="div" className="text-danger" />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label custom-label">Confirm Password*</label>
                                            <Field name="confirmPassword" type={showPassword ? 'text' : 'password'} className="form-control customInputControl" />
                                            <ErrorMessage name="confirmPassword" component="div" className="text-danger" />
                                        </div>

                                        <div className="mb-3">
                                            <label className='custom-label'>
                                                <input
                                                    type="checkbox"
                                                    checked={showPassword}
                                                    onChange={togglePasswordVisibility}
                                                />
                                                &nbsp;Show Password
                                            </label>
                                        </div>

                                        <Button
                                            className="w-100"
                                            type="submit"
                                            variant="primary"
                                            disabled={!(isValid && dirty)}
                                        >
                                            Save
                                        </Button>

                                        {/* <MessageTooltip
                  id='btnLoginDisabledMsg'
                  isDisabledObj={true}
                  tooltipText={firstError}>
                  <Button type="submit" variant="primary" disabled={!isValid || !dirty}>Login</Button>
                </MessageTooltip> */}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            </div>
            <AlertDialog
                dialogId={'successDialog'}
                showDialog={showSuccessDialog}
                body={'New Admin account has successfully created.'}
                onConfirm={handleSuccessDialogClose}
            />
        </>
    );
};

export default CreateAccount;